/** Languages of the app and of a project's drawings. */
export type Locale = 'fr' | 'en' | 'nl';

/** Text for a language, from its three versions: tr(locale, 'Tableau', 'Board', 'Bord'). */
export const tr = (l: Locale, fr: string, en: string, nl: string): string =>
  l === 'fr' ? fr : l === 'nl' ? nl : en;

/** BCP 47 tag for dates and numbers: Belgian French and Dutch, British English. */
export const localeTag = (l: Locale): string => (l === 'fr' ? 'fr-BE' : l === 'nl' ? 'nl-BE' : 'en-GB');
